module.exports = __webpack_public_path__ + "static/media/England_USA.abd023c0.jpeg";